import { render, staticRenderFns } from "./RequestLoading.vue?vue&type=template&id=8c58d5d6&scoped=true"
import script from "./RequestLoading.vue?vue&type=script&lang=js"
export * from "./RequestLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c58d5d6",
  null
  
)

export default component.exports